// extracted by mini-css-extract-plugin
var _1 = "EmailGoogleTemplateEmpty-moduleempty__jqdGl";
export { _1 as "empty" }
